import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import { ShareAltOutlined } from '@ant-design/icons';
import { ShareModalContent } from "./ShareModalContent/ShareModalContent";
import './ShareModal.css';

/**
 * viewMode="menu" renders the trigger as the given row for the header's
 * compact menu (onMenuClick closes that menu) instead of the Share button;
 * the dialog itself is the same either way.
 */
export const ShareModal = ({ viewMode = 'button', onMenuClick, menuRow }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [privacy, setPrivacy] = useState(0);
  const [view, setView] = useState("access");

  const showModal = () => {
    setIsModalVisible(true);
  };

  // Every way out of the dialog — OK, Cancel, the X, or a child closing it
  // after an action — lands the next open on the access view again.
  const closeModal = () => {
    setIsModalVisible(false);
    setPrivacy(0);
    setView("access");
  };

  const openFromMenu = () => {
    onMenuClick?.();
    showModal();
  };

  return (
    <>
      {viewMode === 'menu' ? (
        <div className="share-menu-row" role="menuitem" onClick={openFromMenu}>
          {menuRow}
        </div>
      ) : (
        <Tooltip title="Share" placement="bottom">
          <button className="share-trigger" onClick={showModal} aria-label="Share">
            <ShareAltOutlined />
            <span className="share-trigger__label">Share</span>
          </button>
        </Tooltip>
      )}
      <Modal
        title={(
          <div className="share-modal-heading">
            <span className="share-modal-heading__badge">
              <ShareAltOutlined />
            </span>
            <span className="share-modal-heading__text">
              <span className="share-modal-heading__title">Share</span>
              <span className="share-modal-heading__doc">Invite people or share a link</span>
            </span>
          </div>
        )}
        visible={isModalVisible}
        onOk={closeModal}
        onCancel={closeModal}
        footer={false}
        width={460}
        centered
        destroyOnClose
        className="share-doc-modal"
      >
        <ShareModalContent
          setIsModalVisible={closeModal}
          privacy={privacy}
          setPrivacy={setPrivacy}
          view={view}
          setView={setView}
        />
      </Modal>
    </>
  );
};
